module.exports = __webpack_public_path__ + "img/gold.3583125c.svg";